import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  classifyReauthorizationFailure,
  GraphReauthorizationFailure,
  reauthorizeGraphAccess,
  subscribeToGraphAuthStatus,
} from '../api/graphClient';
import { showToast } from '../components/utils/toast';

const FAILURE_MESSAGE_KEYS: Record<GraphReauthorizationFailure, string> = {
  cancelled: 'common:authenticationCancelled',
  popupBlocked: 'common:graphReauthorization.popupBlocked',
  failed: 'common:somethingWentWrong',
};

export const useGraphAuthStatus = () => {
  const { t } = useTranslation();
  const [needsReauth, setNeedsReauth] = useState(false);
  const [isReauthorizing, setIsReauthorizing] = useState(false);

  useEffect(() => subscribeToGraphAuthStatus(setNeedsReauth), []);

  const reauthorize = useCallback(async () => {
    setIsReauthorizing(true);
    try {
      await reauthorizeGraphAccess();
    } catch (error) {
      // The banner stays up on failure, so without this the user cannot tell a dismissed or blocked
      // popup apart from a button that did nothing.
      console.error('Failed to reauthorize Microsoft Graph access:', error);
      showToast('error', t(FAILURE_MESSAGE_KEYS[classifyReauthorizationFailure(error)]));
    } finally {
      setIsReauthorizing(false);
    }
  }, [t]);

  return { needsReauth, isReauthorizing, reauthorize };
};
